import React from "react";
import { Col, Row } from "reactstrap";
import { useIntl } from "react-intl";
import { FormInputOptions } from "../../../../../cores/webForm/interfaces/formInputOptions";
import {
  AcceptanceLinkUrls,
  getAcceptanceLinkUrls,
  setAcceptanceLinkUrls,
} from "../../../../../cores/webForm/utils/formRender.utils";
import { InputWembii } from "../../../InputWembii";

interface Props {
  options?: FormInputOptions;
  onChange: (options: FormInputOptions) => void;
  inputId: string;
}

export default function AcceptanceLinksEditor({
  options,
  onChange,
  inputId,
}: Props) {
  const intl = useIntl();
  const links = getAcceptanceLinkUrls(options);

  const updateLinks = (patch: Partial<AcceptanceLinkUrls>) => {
    onChange(
      setAcceptanceLinkUrls(options, {
        ...links,
        ...patch,
      })
    );
  };

  return (
    <div className="web-form-editor-ai__acceptance-links">
      <p className="web-form-editor-ai__acceptance-links-title">
        {intl.formatMessage({ id: "app.editForm.acceptanceLinksTitle" })}
      </p>
      <p className="web-form-editor-ai__acceptance-links-hint">
        {intl.formatMessage({ id: "app.editForm.acceptanceLinksHint" })}
      </p>
      <Row className="web-form-editor-ai__acceptance-links-row">
        <Col md="6" xs="12">
          <InputWembii
            type="text"
            name={`termsUrl-${inputId}`}
            id={`termsUrl-${inputId}`}
            placeholder={intl.formatMessage({
              id: "app.editForm.termsUrlPlaceholder",
            })}
            value={links.termsUrl || ""}
            flat
            mb={false}
            onChange={(v) => updateLinks({ termsUrl: v })}
          />
        </Col>
        <Col md="6" xs="12">
          <InputWembii
            type="text"
            name={`privacyUrl-${inputId}`}
            id={`privacyUrl-${inputId}`}
            placeholder={intl.formatMessage({
              id: "app.editForm.privacyUrlPlaceholder",
            })}
            value={links.privacyUrl || ""}
            flat
            mb={false}
            onChange={(v) => updateLinks({ privacyUrl: v })}
          />
        </Col>
      </Row>
    </div>
  );
}
